<template>
    <Breadcrumbs main="Gallery" title="Image Hover Effects" />
    <div class="container-fluid">
        <hoverEffect1 />
        <hoverEffect2 />
        <hoverEffect3 />
        <hoverEffect4 />
        <hoverEffect5 />
        <hoverEffect6 />
        <hoverEffect7 />
        <hoverEffect8 />
        <hoverEffect9 />
        <hoverEffect10 />
        <hoverEffect11 />
        <hoverEffect12 />
        <hoverEffect13 />
        <hoverEffect14 />
        <hoverEffect15 />
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const hoverEffect1 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect1.vue"))
const hoverEffect2 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect2.vue"))
const hoverEffect3 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect3.vue"))
const hoverEffect4 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect4.vue"))
const hoverEffect5 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect5.vue"))
const hoverEffect6 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect6.vue"))
const hoverEffect7 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect7.vue"))
const hoverEffect8 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect8.vue"))
const hoverEffect9 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect9.vue"))
const hoverEffect10 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect10.vue"))
const hoverEffect11 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect11.vue"))
const hoverEffect12 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect12.vue"))
const hoverEffect13 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect13.vue"))
const hoverEffect14 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect14.vue"))
const hoverEffect15 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect15.vue"))
</script>